/**
 * SiteUp (2026-08-26): os modos de ordenação que a fila oferece.
 *
 * Eram sete. Ficaram dois, a pedido do Lucas: sete opções para decidir "por
 * onde eu começo" é escolha demais para pouca diferença prática. Saíram
 * "não lidas primeiro", "atividade mais antiga", "conversas mais novas",
 * "conversas mais antigas" e "prioridade".
 *
 * A ordem aqui é a ordem do menu, e o primeiro é o padrão da fila
 * (DEFAULT_CONVERSATION_VIEW_MODE): mais recentes no topo, como no WhatsApp
 * (decisão de 23/09/2026).
 *
 * Esta lista é a fonte única: o seletor desenha a partir dela e o ChatList
 * valida o modo salvo contra ela. Sem isso, quem tivesse um dos modos
 * removidos salvo em uiSettings continuaria ordenando por ele, sem opção de
 * trocar pelo menu.
 */
export const VIEW_MODES = [
  {
    value: 'last_activity_desc',
    i18nKey: 'LAST_ACTIVITY_DESC',
    icon: 'i-ri-time-line',
  },
  { value: 'waiting', i18nKey: 'WAITING', icon: 'i-ri-hourglass-line' },
];

export const SORT_MODES_DISPONIVEIS = VIEW_MODES.map(m => m.value);

export const ehModoValido = modo => SORT_MODES_DISPONIVEIS.includes(modo);
